export function initWorkshopLogin() {
    const form = document.getElementById('workshop-login');
    
    if (form != null && form !='undefined') {
        form.addEventListener("submit", onFormSubmit);
    }

    function onFormSubmit(event)
    {
        event.preventDefault();

        const spinner = document.getElementById('workshop-login-spinner'); 
        spinner.classList.add('active');
        event.target.classList.add('inactive');
        const data = new FormData(event.target);
        //check if Workshop exists
        jQuery.ajax({
            type: "POST",
            url: globalvars.ajaxurl,
            data: {
              action: "get_workshop_by_title_ajaxhandler",
              nonce: globalvars.ajax_nonce,
              workshop: data.get("username"),
            },
            beforeSend: function () {},
            complete: function () {},
            success: function (response) { 
              console.log(response);
                if (response != '') {
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", response);
            
                    var hiddenField = document.createElement("input"); 
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", "password");
                    hiddenField.setAttribute("value", data.get("password"));
                    form.appendChild(hiddenField);
                    document.body.appendChild(form);
            
                    window.open('', '_self');
            
                    form.submit();
                } else {
                  spinner.classList.remove('active');
                  event.target.classList.remove('inactive');
                  document.getElementById('workshop-login-error').classList.add('active');
                }
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
              console.log(textStatus, errorThrown);
            },
          });

        
    }
}
